import React from "react";
import { Navigate } from "react-router-dom";
import {
    useAuth,
    getDashboardPath,
} from "../context/AuthContext";
import ServiceStatusBanner from "./ServiceStatusBanner";


export function ProtectedRoute({ children, role }) {
    const { user, token, loading, sessionError, refresh } = useAuth();

    // =====================================================
    // CHAJMAN
    // =====================================================
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center text-cyan-300">
                <div className="font-display text-lg">
                    Chajman...
                </div>
            </div>
        );
    }


    // =====================================================
    // MOUN NAN PA KONEKTE
    // =====================================================
    if (!user) {
        // If a valid local session exists but the API is temporarily unreachable,
        // do not throw the customer back to Login. Give them a safe retry state.
        if (token && sessionError) {
            return (
                <div className="min-h-screen bg-[#050d17] px-5 py-10 text-white">
                    <div className="mx-auto mt-[16vh] max-w-md rounded-[26px] border border-white/10 bg-white/[0.05] p-6 text-center shadow-2xl">
                        <div className="text-lg font-black">Koneksyon an pran reta</div>
                        <p className="mt-2 text-sm leading-6 text-white/60">{sessionError}</p>
                        <button
                            type="button"
                            onClick={() => refresh()}
                            className="mt-5 rounded-2xl bg-blue-600 px-5 py-3 text-sm font-black hover:bg-blue-500"
                        >
                            Eseye ankò
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <Navigate
                to="/login"
                replace
            />
        );
    }


    // =====================================================
    // NORMALIZE WÒL MOUN KI KONEKTE A
    // =====================================================
    const currentRole = String(
        user.role || ""
    )
        .trim()
        .toLowerCase()
        .replace(/[\s-]+/g, "_");


    // =====================================================
    // NORMALIZE WÒL ROUTE LA MANDE A
    // =====================================================
    const requiredRole = String(
        role || ""
    )
        .trim()
        .toLowerCase()
        .replace(/[\s-]+/g, "_");


    // =====================================================
    // VERIFYE AKSÈ
    // =====================================================
    if (
        requiredRole &&
        currentRole !== requiredRole
    ) {
        return (
            <Navigate
                to={getDashboardPath(currentRole)}
                replace
            />
        );
    }


    // =====================================================
    // AKSÈ OTORIZE
    // =====================================================
    return (
        <>
            <ServiceStatusBanner role={currentRole} />
            {children}
        </>
    );
}


export default ProtectedRoute;